module.exports = __webpack_public_path__ + "themes/mf/img/prize-1@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-1@2x.png
// module id = 87
// module chunks = 3